import { useContext, useEffect, useState } from "react";
import LogFilters from "../../../../components/Admin/Processes/ETL-Process-Log/LogFilters/LogFilters";
import LogTable from "../../../../components/Admin/Processes/ETL-Process-Log/LogTable/LogTable";
import { ETLLogsEndPointLogic } from "../../../../logic/Admin/ETLChains/ETLLogsEndPointLogic";
import SimpleBackdrop from "../../../../components/BackDrop/BackDrop";
import store from "../../../../store";
import { selectUserData, setIsLoading } from "../../../../features/userSlice";
import SharedStateContext from "../../../../components/SharedStateProvider";
import { useSelector } from "react-redux";
import Page404 from "../../../../components/Page404/Page403";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { trackPromise } from "react-promise-tracker";
import { ETLProcessListEndPointLogic } from '../../../../logic/Admin/ETL Process List/ETLProcessListEndPointLogic';
export default function ETLProcessLogScreen(userToken: any) {
  const token = userToken?.userToken;
  let websiteSharedUids = userToken?.response?.website_permissions;
  let websiteSharedUid = websiteSharedUids.map(
    (item: any) => Object.keys(item)[0]
  );
  const [logs, setLogs] = useState([]) as any;
  const [error] = useState("") as any;
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState() as any;
  const [selectedMethod, setSelectedMethod] = useState() as any;
  const [selectedName, setSelectedName] = useState() as any;
  const [selectedLastRun, setSelectedLastRun] = useState<[any, any]>([
    null,
    null,
  ]);
  const [filteredLogsByLastRun, setFilteredLogsByLastRun] = useState(logs);
  const [rowID, setRowID] = useState(null) as any;
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [selectedRows, setSelectedRows] = useState([]) as any;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [processId, setProcessId] = useState(null) as any;
  const [totalRecords, setTotalRecords] = useState(0);
  const [isNextButton, setIsNextButton] = useState(false);
  const [isPrevButton, setIsPrevButton] = useState(false);
  const { setLoad, load } = useContext(SharedStateContext);
  const response = useSelector(selectUserData);
  const hasViewProcessLogsPermission = CheckPermissions(
    response?.data?.products?.admin,
    "processes",
    "view_processes_logs"
  );
  let formattedDates =
    selectedLastRun?.length === 2 && selectedLastRun[0] && selectedLastRun[1]
      ? selectedLastRun.map((date: any) => {
          // Check if date is already a dayjs object
          const d = dayjs.isDayjs(date) ? date : dayjs(date);
          const year = d.year();
          const month = String(d.month() + 1).padStart(2, "0"); // Months are 0-indexed
          const day = String(d.date()).padStart(2, "0");
          return `${year}-${month}-${day}`; // Format in yyyy-mm-dd
        })
      : []; // Return an empty array if there aren't exactly 2 dates
  const fromDate: any = formattedDates.length !== 0 ? formattedDates[0] : null;
  const toDate: any = formattedDates.length !== 0 ? formattedDates[1] : null;
  const [isClearFilter, setIsClearFilter] = useState(false);
  const [showLastRunOnly, setShowLastRunOnly] = useState(false);
  const [filteredLogs, setFilteredLogs] = useState<any[]>([]);
  const [searchParams] = useSearchParams();
  const processIdFromURL = searchParams.get("search");
  const statusFromURL = searchParams.get("status");
  const methodFromURL = searchParams.get("method");
  const startDateFromURL = searchParams.get("startDate");
  const endDateFromURL = searchParams.get("endDate");
  const pageFromURL = parseInt(searchParams.get("page") || "0", 10);
  const runIdFromURL = searchParams.get("run_id");
  const responseRunIdFromURL = searchParams.get("response_run_id");
  const [page, setPage] = useState(pageFromURL);
  const [processes, setProcesses] = useState([]) as any;

  useEffect(() => {
    if (responseRunIdFromURL) {
      const newSearchParams = new URLSearchParams(window.location.search);
      newSearchParams.delete("response_run_id");
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${newSearchParams}`
      );
    }
  }, [responseRunIdFromURL]);
  useEffect(() => {
    if (statusFromURL) {
      setSelectedStatus(statusFromURL.split(","));
    }
    if (methodFromURL) {
      setSelectedMethod(methodFromURL.split(","));
    }
    if (startDateFromURL && endDateFromURL) {
      setSelectedLastRun([dayjs(startDateFromURL), dayjs(endDateFromURL)]);
    }
  }, [
    statusFromURL,
    methodFromURL,
    startDateFromURL,
    endDateFromURL,
    pageFromURL,
    runIdFromURL,
  ]);
  const fetchLogs = async () => {
    store.dispatch(setIsLoading(true));
    setLoading(true);
    if (
      isClearFilter ||
      (toDate && !isNextButton) ||
      (selectedMethod && !isNextButton) ||
      (selectedStatus && !isNextButton) ||
      (selectedLastRun && !isNextButton)
    ) {
      setLogs([]);
      // eslint-disable-next-line
      formattedDates = [];
      if (!pageFromURL) {
        setPage(0);
      }
    }
    const handleLogs = (newLogs: any) => {
      setLogs((prevLogs: any) => {
        const existingRunIds = new Set(prevLogs.map((log: any) => log.run_id));
        const uniqueNewLogs = newLogs.filter(
          (log: any) => !existingRunIds.has(log.run_id)
        );
        return [...prevLogs, ...uniqueNewLogs];
      });
    };
    const logsHandler =
      formattedDates && formattedDates.length !== 0 && isNextButton
        ? handleLogs
        : selectedMethod && selectedMethod.length !== 0 && isNextButton
        ? handleLogs
        : selectedStatus && selectedStatus.length !== 0 && isNextButton
        ? handleLogs
        : processId !== null && isNextButton
        ? handleLogs
        : (selectedStatus && selectedStatus.length !== 0) ||
          (selectedMethod && selectedMethod.length !== 0) ||
          (formattedDates && formattedDates.length !== 0) ||
          processId !== null ||
          processIdFromURL
        ? setLogs
        : handleLogs;
    const fromDateParam = isClearFilter
      ? null
      : fromDate
      ? fromDate
      : startDateFromURL;
    const toDateParam = isClearFilter ? null : toDate ? toDate : endDateFromURL;
    const rowParam = rowID ? rowID : runIdFromURL;

    try {
      await 
      await Promise.all([
        // ETLProcessListEndPointLogic.getETLProcessList(token,setProcesses,trackPromise),
        ETLProcessListEndPointLogic.getProcessList(token, setProcesses, trackPromise),
        ETLLogsEndPointLogic.getLogs(
        token,
        logsHandler,
        setTotalRecords,
        rowsPerPage,
        rowParam,
        selectedStatus || (statusFromURL ? statusFromURL.split(",") : []), // Ensure it's always an array
        selectedMethod || (methodFromURL ? methodFromURL.split(",") : []), // Ensure it's always an array
        fromDateParam,
        toDateParam,
        processIdFromURL ? processIdFromURL : processId
      )
      ]);
    } catch (error) {
      console.error("Failed to fetch logs:", error);
    } finally {
      store.dispatch(setIsLoading(false));
      setLoading(false);
      setRefresh(false);
      setLoad(false);
      setIsNextButton(false);
      setIsClearFilter(false);
    }
  };
  useEffect(() => {
    if (userToken && !isPrevButton) {
      if (refresh) {
        setLoading(true);
        setRefresh(false);
        const timeoutId = setTimeout(() => {
          setLogs([]);
          fetchLogs();
        }, 5000);
        return () => clearTimeout(timeoutId);
        // Cleanup in case of unmount
      } else {
        fetchLogs();
      }
    }
    // eslint-disable-next-line
  }, [
    load,
    refresh,
    rowsPerPage,
    selectedStatus,
    selectedMethod,
    toDate,
    page,
    showLastRunOnly,
    processIdFromURL,
    fromDate,
  ]);
  useEffect(() => {
    // If navigating backward, remove the last `rowsPerPage` logs
    if (isPrevButton) {
      setLogs((prevLogs: any) =>
        prevLogs.slice(
          0,
          logs.length % rowsPerPage === 0
            ? -rowsPerPage
            : -(logs.length % rowsPerPage)
        )
      );
      setIsPrevButton(false);
    }
    // eslint-disable-next-line
  }, [isPrevButton === true]);

  useEffect(() => {
    if (pageFromURL > 0 && page > 0) {
      const newSearchParams = new URLSearchParams(window.location.search);
      newSearchParams.set("page", "0"); // Set page to 0
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${newSearchParams}`
      );
      setPage(0); // Update the state
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const tableHeadings = {
    run_id: "Run ID",
    process_name: "Process Name",
    start_time: "Started At",
    end_time: "Ended At",
    record_total: "Fetched",
    record_created: "Created",
    record_updated: "Updated",
    status: "Status",
    response: "Response",
    // "run_by": "Run By",
    run_method: "Method",
    info: "Info",
  };

  return (
    <>
      {hasViewProcessLogsPermission ? (
        <div>
          <LogFilters
            tableHeadings={tableHeadings}
            refresh={refresh}
            setRefresh={setRefresh}
            logs={logs}
            setLogs={setLogs}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            setSelectedMethod={setSelectedMethod}
            selectedMethod={selectedMethod}
            setFilteredLogsByLastRun={setFilteredLogsByLastRun}
            selectedIds={selectedIds}
            token={token}
            setSelectedIds={setSelectedIds}
            setSelectedName={setSelectedName}
            selectedName={selectedName}
            page={page}
            setPage={setPage}
            websiteSharedUid={websiteSharedUid}
            setSelectedLastRun={setSelectedLastRun}
            selectedLastRun={selectedLastRun}
            setRowID={setRowID}
            setProcessId={setProcessId}
            selectedRows={selectedRows}
            setIsClearFilter={setIsClearFilter}
            setShowLastRunOnly={setShowLastRunOnly}
            showLastRunOnly={showLastRunOnly}
            setFilteredLogs={setFilteredLogs}
            setProcesses={setProcesses}
            processes={processes}
          />
          {loading ? (
            <SimpleBackdrop />
          ) : (
            <LogTable
              tableHeadings={tableHeadings}
              logs={logs}
              selectedStatus={selectedStatus}
              selectedMethod={selectedMethod}
              error={error}
              setRefresh={setRefresh}
              filteredLogsByLastRun={filteredLogsByLastRun}
              setSelectedIds={setSelectedIds}
              selectedIds={selectedIds}
              setSelectedName={setSelectedName}
              selectedName={selectedName}
              page={page}
              setPage={setPage}
              setRowsPerPage={setRowsPerPage}
              rowsPerPage={rowsPerPage}
              setRowID={setRowID}
              rowID={rowID}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              totalRecords={totalRecords}
              setIsNextButton={setIsNextButton}
              setIsPrevButton={setIsPrevButton}
              isClearFilter={isClearFilter}
              setFilteredLogs={setFilteredLogs}
              filteredLogs={filteredLogs}
            />
          )}
        </div>
      ) : (
        <Page404 />
      )}
    </>
  );
}
